export default __webpack_public_path__ + "static/media/file_error.e7181a99.svg";